import { useRouter } from 'next/router';
import React, { useEffect } from 'react';
import URI from 'urijs';
import { windowWrapper } from '@clubmed/utils';
import { useAppContext } from 'Context/ReactAppContext';
import * as pleUtils from 'Utils/ple-utils';
import { isFeatureFlipped } from 'Utils/feature-flipping/featureFlippingUtils';
const { redirectOnLoginPage, hasAuthResponseError, hasNotFoundError } = pleUtils;
export function useGQLErrorsHandler(...params: any) {
  const { asPath } = useRouter();
  const pathname = new URI(asPath).pathname();
  const appContext = useAppContext();

  // Need at least Query & Options
  if (params.length < 2) {
    throw new Error('useGQLErrorsHandler must have at least an error and an option configuration');
  }

  const options = params[params.length - 1];
  const errors = params.slice(0, params.length - 1);

  if (
    !options.hasOwnProperty('catchAuthError') &&
    !options.hasOwnProperty('catchNotFoundError') &&
    !options.hasOwnProperty('handler')
  ) {
    throw new Error(
      'The last params must be the options configuration (catchAuthError, catchNotFoundError, handler)',
    );
  }

  useEffect(() => {
    const containAuthError = !!errors.find(hasAuthResponseError);
    const containNotFoundError = !!errors.find(hasNotFoundError);

    if (options.catchAuthError && containAuthError) {
      redirectOnLoginPage({
        locale: appContext.locale,
        redirectPath: pathname,
        isQuickLoginFirst: isFeatureFlipped(appContext)('memberSpace.isQuickLoginFirst'),
        isSeller: appContext.isSeller,
        isCmta: appContext.isCmta,
      });
      return;
    }

    if (options.catchNotFoundError && containNotFoundError) {
      windowWrapper.setLocation('/404');
      return;
    }

    if (options.handler && errors.some(Boolean)) {
      options.handler(errors);
    }
  }, errors);
}
